var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusProducerVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 12,
    viewBox: "0 0 30 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.512 12 .687.134h2.618l1.768 5.695.935 3.723h.051l.901-3.723L8.728.134h2.533L7.402 12h-2.89Zm7.844 0V9.943h1.53V2.191h-1.53V.134H18v2.057h-1.53v7.752H18V12h-5.644Zm7.797 0V.134h5.61c.555 0 1.054.096 1.496.289.442.181.816.436 1.122.765.317.329.56.731.73 1.207.17.465.256.975.256 1.53 0 .567-.085 1.082-.255 1.547a3.34 3.34 0 0 1-.731 1.19c-.306.329-.68.59-1.122.782a3.91 3.91 0 0 1-1.496.272h-3.026V12h-2.584Zm2.584-6.528h2.72c.385 0 .685-.096.9-.289.227-.204.34-.499.34-.884v-.748c0-.385-.113-.674-.34-.867-.215-.204-.515-.306-.9-.306h-2.72v3.094Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusProducerVip);
export default __webpack_public_path__ + "static/media/status-producer-vip.2afc066c10b2e035d036bddb45d150b7.svg";
export { ForwardRef as ReactComponent };